<template>
    <modal @click="close">
        <div @click.stop class="content">
            <form @submit.prevent="checkEmail"
                  v-if="checkEmailStatus.status.name!='resolved'">

                <h3>Login or Register</h3>
                <input type="email" v-model="email" placeholder="Email" required>
                <button :class="{isLoading:checkEmailStatus.status.name=='pending'}">Continue</button>
            </form>
            <div v-else>
                <form v-if="checkEmailStatus.data=='login'" @submit.prevent="login">

                    <h3>Login</h3>
                    <input type="password" v-model="password" placeholder="Password" required
                           autocomplete="current-password">
                    <button :class="{isLoading:loginStatus.status.name=='pending'}">Login</button>
                </form>
                <form v-else-if="checkEmailStatus.data=='register'" @submit.prevent="register">
                    <h3>Register</h3>
                    <input name="password2" type="password" v-model="password" placeholder="Password" required
                           autocomplete="new-password">
                    <input name="password2" type="password" v-model="password2" placeholder="Repeat password" required
                           autocomplete="new-password">
                    <button :class="{isLoading:registerStatus.status.name=='pending'}">Register</button>
                </form>
                <div v-else-if="checkEmailStatus.data=='noPasswordSet'">
                    <p>Account created without password</p>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import {Api} from "@/api";
import ReactivePromiseStatus from "reactive-promise-status/dist/reactive-promise-status";

export default {
    data() {
        return {
            email: '',
            checkEmailStatus: new ReactivePromiseStatus(),
            loginStatus: new ReactivePromiseStatus(),
            registerStatus: new ReactivePromiseStatus(),
            password: '',
            password2: '',
        }
    },
    methods: {
        checkEmail() {
            this.checkEmailStatus.promise = Api.account.checkEmail({email: this.email});

            window.gtag('event', 'checkingEmail', {})
        },
        async login() {
            window.gtag('event', 'tryLogin', {})
            this.loginStatus.promise = Api.account.loginClassic({email: this.email, password: this.password})
            localStorage.setItem('token', await this.loginStatus)
            this.$store.dispatch('checkLogin')
            this.close()
            window.gtag('event', 'login', {})
        },
        async register() {
            window.gtag('event', 'tryRegister', {})
            this.registerStatus.promise = Api.account.registerClassic({
                email: this.email,
                password: this.password,
                password2: this.password2
            })
            localStorage.setItem('token', await this.registerStatus)
            this.$store.dispatch('checkLogin')
            this.close()
            window.gtag('event', 'register', {})
        },
        close() {
            this.$emit('close');
        }
    },
    watch: {
        checkEmailStatus() {
            this.password = ''
            this.password2 = ''
            this.loginStatus.promise = null
            this.registerStatus.promise = null
        }
    }
}
</script>
